import { AfterViewInit, Component, computed, ElementRef, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import {
	faAngleDown,
	faArrowUpRightFromSquare,
	faBan,
	faCheckSquare,
	faCircleCheck,
	faEye,
	faFile,
	faFileArrowUp,
	faMagnifyingGlass,
	faPencil,
	faSortDown,
	faSortUp,
	faSquare,
	faTimes,
	faTrash,
	faTriangleExclamation,
} from '@fortawesome/free-solid-svg-icons';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { CmdbHomeScreenService } from './service/cmdb-home-screen.service';
import { ciInterface2 } from 'src/app/util/interfaces/ci';
import { DateService } from 'src/app/services/date/date.service';
import { catchError, forkJoin, of, Subscription } from 'rxjs';
import { ciTypesInterface } from 'src/app/util/interfaces/ciTypes';
import { locationInterface } from 'src/app/util/interfaces/locationInterface';
import { enduserInterface } from 'src/app/util/interfaces/enduser';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { StatusInterfaceCMDB } from 'src/app/util/interfaces/statusInterface';
import { genericFormI } from 'src/app/util/interfaces/genericFormRMK';
import { ExcelService } from 'src/app/services/excel/excel.service';
import { LoadingNotificationService } from 'src/app/services/loading-notification/loading-notification.service';
import { CmdbDigitalTerm } from 'src/app/util/interfaces/cmdbDigitalTerm';
import { FilesService } from 'src/app/services/files/files.service';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { iacOptionInterface } from 'src/app/page_component_item/input-with-autocomplete/input-with-autocomplete.component';
import { PermissionService } from 'src/app/util/services/permission/permission.service';
import { ModalComponent } from 'src/app/page_component_item/modal/modal.component';
import { CmdbPermissions } from 'src/app/util/interfaces/cmdbPermissions';
import { CmdbPermissionsService } from '../cmdb-permissions/service/cmdb-permissions.service';
import { tableCellI } from 'src/app/util/interfaces/tableCell';
import { tableLineI } from 'src/app/util/interfaces/tableLine';
import { normalizeString } from 'src/app/services/string/string.service';
import { CryptoService } from 'src/app/services/crypto/crypto.service';
import { CmdbRegisterPageService } from '../cmdb-register-page/service/cmdb-register-page.service';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { ShkDate } from 'shk-date';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';
import { mspFileInterface } from 'src/app/util/interfaces/mspFile';
import { BreadcrumbNavigationComponent } from 'src/app/page_component_item/breadcrumb-navigation/breadcrumb-navigation.component';
import { ToggleSwitchModule } from 'src/app/page_component_item/toggle-switch/toggle-switch.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CommonModule } from '@angular/common';
import { MspTableRmkComponent } from 'src/app/page_component_item/msp-table-rmk/msp-table-rmk.component';
import { PaginationCounterModule } from 'src/app/page_component_item/pagination-counter/pagination-counter.module';
import { GenericFormGenModule } from 'src/app/page_component_item/generic-form-gen/generic-form-gen.module';
import { MspButtonComponent } from 'src/app/page_component_item/msp-button/msp-button.component';
import { InputWithAutocompleteModule } from 'src/app/page_component_item/input-with-autocomplete/input-with-autocomplete.module';
import { FormsModule } from '@angular/forms';
import { DotBounceLoadingEffectModule } from 'src/app/page_component_item/dot-bounce-loading-effect/dot-bounce-loading-effect.module';
import { RingLoadingEffectComponent } from 'src/app/page_component_item/ring-loading-effect/ring-loading-effect.component';
import { SvgGearsModule } from 'src/app/page_component_item/svg-gears/svg-gears.module';
import { mspTableHeaderI } from 'src/app/page_component_item/msp-table/msp-table.component';
import { contextMenuOptions } from 'src/app/services/context-menu/context-menu.service';
import { CMDB_PERMISSIONS_BY_TYPE } from '../cmdb-permissions/service/cmdb-permissions.definition';
import { TooltipDirective } from 'src/app/util/directives/tooltip/tooltip.directive';
import { mspTableSort } from 'src/app/page_component_item/msp-table-rmk/components/msp-table.interfaces';
import { CmdbRegisterPageAttachmentService } from '../cmdb-register-page/components/cmdb-register-page-attachment/data/cmdb-register-page-attachment.service';
@Component({
	standalone: true,
	imports: [
		BreadcrumbNavigationComponent,
		ToggleSwitchModule,
		FontAwesomeModule,
		CommonModule,
		MspTableRmkComponent,
		PaginationCounterModule,
		GenericFormGenModule,
		MspButtonComponent,
		InputWithAutocompleteModule,
		FormsModule,
		DotBounceLoadingEffectModule,
		ModalComponent,
		RingLoadingEffectComponent,
		SvgGearsModule,
		RouterModule,
	],
	selector: 'app-cmdb-home-screen',
	templateUrl: './cmdb-home-screen.component.html',
	styleUrl: './cmdb-home-screen.component.scss',
})
export class CmdbHomeScreenComponent implements OnInit {
	private readonly cmdbListFiltersStorageKey = 'cmdbListFilters';

	@ViewChild('actionsTemplate', { static: true }) actionsTemplate: TemplateRef<any>;

	icons = {
		faSquare: faSquare,
		faCheckSquare: faCheckSquare,
		faAngleDown: faAngleDown,
		faSortDown: faSortDown,
		faPencil: faPencil,
		faEye: faEye,
		faTrash: faTrash,
		faMagnifyingGlass: faMagnifyingGlass,
		faSortUp: faSortUp,
		faTimes: faTimes,
		faFile: faFile,
		faArrowUpRightFromSquare: faArrowUpRightFromSquare,
		faTriangleExclamation: faTriangleExclamation,
		faCircleCheck: faCircleCheck,
		faBan: faBan,
		faFileArrowUp: faFileArrowUp,
	};

	labels: LabelsInterface;

	@ViewChild('importCisModal') importCisModal: ModalComponent;
	@ViewChild('importFile') importFile: ElementRef;
	@ViewChild('importAttachmentFile') importAttachmentFile: ElementRef;

	constructor(
		private LabelsService: LabelsService,
		private CmdbHomeScreenService: CmdbHomeScreenService,
		private CmdbRegisterPageService: CmdbRegisterPageService,
		private CmdbRegisterPageAttachmentService: CmdbRegisterPageAttachmentService,
		private ExcelService: ExcelService,
		private LoadingNotificationService: LoadingNotificationService,
		private Router: Router,
		private ActivatedRoute: ActivatedRoute,
		private CryptoService: CryptoService,
		private ProfileService: ProfileService,

		public DateService: DateService,
		public NotificationService: NotificationService,
		public FilesService: FilesService,
		public PermissionService: PermissionService,
		public CmdbPermissionsService: CmdbPermissionsService
	) {
		this.labels = computed(() => this.LabelsService.labels())();
		(window as any).debugToggle = (value: boolean) => {
			this.debugImport = value;
		};
	}

	isLoadingCiTable = true;
	isLoadingCiTableHeader = true;
	isLoadingAvailableViewColumns = true;
	isLoadingImportInfo = true;
	isFirstLoad = true;
	importHasError = false;

	isLoadingDigitalTerm = false;
	isUpdatingDigitalTerm = false;
	isUpdatingCiField = false;
	isLoadingViewColumns = false;
	isImportingCis: boolean[] = [];
	importIdNotification: number;

	selectedModal = '';

	requiredPermissions: CmdbPermissions[] = [];
	defaultCiTableColumns = [
		'id',
		'type',
		'identification',
		'status',
		'location',
		'impact',
		'sub_type',
		'manufacturer',
		'model',
		'digital_term_status',
	];
	availableCiTableColumns: genericFormI<'item'>[] = [];
	ciTableCount = 0; //Count without considering pagination
	itemsPerPage = 20;
	ciTablePage = 1;
	recount = true;
	ciTableHeader: mspTableHeaderI[] = [];
	ciTableArr: ciInterface2[] = [];
	ciTableData = () => {
		return this.ciTableArr.map((ci, index) => {
			for (const key of Object.keys(ci)) {
				if (this.labels[ci[key]]) {
					ci[key] = this.labels[ci[key]];
				}
			}
			return ci;
		});
	};
	ciTableArrCount = 0;
	tableSort: mspTableSort = { sortBy: '', sortOrder: 'asc', sortDown: false };
	tableSearch: { [key: string]: any } = {};
	selectedCiTableArr: ciInterface2[] = [];
	cmdbContextMenu: contextMenuOptions[];
	showInactiveCis = false;

	availableLocation: locationInterface[] = [];
	availableStatus: StatusInterfaceCMDB[] = [];
	availableEnduser: enduserInterface[] = [];
	availableEnduserIAC: iacOptionInterface[] = [];

	cmdbDigitalTermPayload: CmdbDigitalTerm | null = null;
	cmdbDigitalTermPayloadCopy: CmdbDigitalTerm | null = null;

	selectedIndex: any = null;
	isEditingTerm = false;

	dropdown = {
		name: '',
		x: 0,
		y: 0,
	};

	searchCiTableReq: Subscription;
	digitalTermReq: Subscription;

	cmdbFields: genericFormI[] = [];
	editField: genericFormI;

	importHeaderFields: genericFormI[] = [];
	importBodyFields: tableLineI[] = [];
	importAllFields = {};
	importFileName = '';
	importAttachment: mspFileInterface | null = null;
	importAttachmentName = '';
	isLoadingImportAttachment = false;
	importNewCiCount = 0;
	importUpdateCiCount = 0;
	importErrorCiCount = 0;
	runnedImport = false;
	finishedImport = false;
	importedCmdbIds: string[] = [];
	debugImport = false;

	// Parâmetros de filtro pendentes da URL
	private pendingUrlParams: any = null;
	cmdbListQueryParams = this.ActivatedRoute.snapshot.queryParams;

	ngOnInit(): void {
		const cmdbhpShowInactiveCis = localStorage.getItem('cmdbhpShowInactiveCis');
		if (cmdbhpShowInactiveCis == undefined) {
			this.setLocalstorage('cmdbhpShowInactiveCis', false);
		} else {
			this.showInactiveCis = cmdbhpShowInactiveCis.toString() == 'true';
		}

		forkJoin([
			this.CmdbHomeScreenService.getAvailableLocation(),
			this.CmdbHomeScreenService.getAvailableStatus(),
			this.CmdbHomeScreenService.getAvailableUsers(),
		]).subscribe({
			next: (forkRes) => {
				const location = forkRes[0];
				const status = forkRes[1];
				const endusers = forkRes[2];

				this.availableLocation = location;
				this.availableStatus = status;
				// this.availableStatus.forEach(status => {
				//   if(status.status_active == 1) this.search.status.push(status.status);
				// })
				this.availableEnduser = endusers;
				for (const enduser of this.availableEnduser) {
					const newIAC: iacOptionInterface = {
						name: `${enduser.fullName} (${enduser.email})`,
						value: enduser.fullName,
					};
					this.availableEnduserIAC.push(newIAC);
				}
			},
		});

		// Carregar filtros da URL se existirem
		this.loadFiltersFromUrl();
		this.getCmdbTableColumns();

		forkJoin([this.CmdbHomeScreenService.getAvailableCMDBViewColumns()]).subscribe({
			next: (forkRes) => {
				this.availableCiTableColumns = forkRes[0][0].items;
				this.isLoadingAvailableViewColumns = false;
				// Só chama searchCITable se não houver filtros pendentes da URL
				// Se houver, o applyPendingUrlFilters() já vai fazer a busca
				if (!this.pendingUrlParams) {
					this.searchCITable(1);
				}
			},
		});

		forkJoin([this.CmdbHomeScreenService.getImportHeaders(), this.CmdbHomeScreenService.getImportAllFields()])
			.subscribe({
				next: (forkRes) => {
					const importHeader = forkRes[0];
					const allCmdbFields = forkRes[1];

					this.importHeaderFields = importHeader;
					this.importAllFields = allCmdbFields;

					const disabledCmdbFields = new Set(['id', 'type', 'customer', 'active']);
					for (const cmdbFieldKeys of Object.keys(allCmdbFields['cmdb'])) {
						if (!disabledCmdbFields.has(cmdbFieldKeys)) this.cmdbFields.push(allCmdbFields['cmdb'][cmdbFieldKeys]);
					}
				},
			})
			.add(() => {
				this.isLoadingImportInfo = false;
			});

		this.requiredPermissions = CMDB_PERMISSIONS_BY_TYPE;
		this.refreshCmdbContextMenu();
		this.finishLoading();
	}

	async finishLoading() {
		await this.until(
			() => this.isLoadingAvailableViewColumns == false && this.isLoadingCiTableHeader == false && this.isFirstLoad == false
		);
	}

	until(conditionFunction: Function) {
		const poll = (resolve) => {
			if (conditionFunction()) resolve();
			else setTimeout(() => poll(resolve), 400);
		};

		return new Promise(poll);
	}

	mapGenericInputTypeToTableColType(inputType: genericFormI['inputType']): mspTableHeaderI['colType'] {
		switch (inputType.toLowerCase()) {
			case 'string': {
				return 'text';
			}
			case 'select': {
				return 'multi-select';
			}
			default: {
				return 'text';
			}
		}
	}

	setGeneralSearch(e: KeyboardEvent): void {
		if (e.key == 'Enter') {
			this.searchCITable(1);
			return;
		}

		this.recount = true;
		this.tableSearch.general = (<any>e.target).value;
	}

	exportCITable(): void {
		const idNotificaton = this.LoadingNotificationService.setNotificationMessage(
			`${this.labels.lbl_geral_relatorio} - 'CMDB'`,
			'loading',
			'faFileAlt'
		);
		this.CmdbHomeScreenService.exportCiTable(
			this.tableSearch,
			this.tableSort.sortBy,
			this.tableSort.sortDown,
			this.showInactiveCis
		).subscribe({
			next: (ciTable2dArray) => {
				this.ExcelService.exportAsExcelFile(ciTable2dArray, 'CMDB');
				this.LoadingNotificationService.updateNotificationStatus(idNotificaton, 'success');
			},
			error: () => {
				this.LoadingNotificationService.updateNotificationStatus(idNotificaton, 'error');
			},
		});

		this.selectedModal = '';
	}

	downloadImportTemplate(): void {
		const idNotificaton = this.LoadingNotificationService.setNotificationMessage(`importTemplate`, 'loading', 'faFileAlt');
		this.CmdbHomeScreenService.getImportHeadersTable().subscribe({
			next: (headerExcelFormatRes) => {
				this.ExcelService.exportAsExcelFile(headerExcelFormatRes, 'importTemplate');
				this.LoadingNotificationService.updateNotificationStatus(idNotificaton, 'success');
			},
			error: (error) => {
				console.error(error);
				this.LoadingNotificationService.updateNotificationStatus(idNotificaton, 'error');
			},
		});
	}

	exportImportErrorsToExcel(): void {
		const errorLines = this.importBodyFields.filter((line) => line.alert?.on === true);

		if (errorLines.length === 0) {
			this.NotificationService.setNotificationMessage('Nenhum erro encontrado para exportacao');
			return;
		}

		const headerRow = [
			...this.importHeaderFields.map((header) => (this.labels[header.label] ? this.labels[header.label] : header.label)),
			'Erro',
		];
		const excelRows = [
			headerRow,
			...errorLines.map((line) => [
				...this.importHeaderFields.map((_, index) => (line.cells[index] ? line.cells[index].label : '')),
				line.alert?.tip || '',
			]),
		];

		this.ExcelService.exportAsExcelFile(excelRows, 'cmdb-import-errors');
	}

	private getImportHeaderLabel(header: genericFormI): string {
		return this.labels[header.label] ? this.labels[header.label] : header.label;
	}

	private buildImportCellErrorMessage(header: genericFormI, rawValue: any, reason: string): string {
		const headerLabel = this.getImportHeaderLabel(header);
		const value = rawValue != undefined && `${rawValue}`.trim() !== '' ? ` "${rawValue}"` : '';
		return `Coluna ${headerLabel}: ${reason}${value}`;
	}

	handleImportFile(E: Event): void {
		this.importBodyFields = [];
		this.importNewCiCount = 0;
		this.importUpdateCiCount = 0;
		this.importErrorCiCount = 0;
		this.FilesService.MSPFileFromFile((<HTMLInputElement>E.target).files[0]).then((mspFile) => {
			this.importFileName = `${mspFile.name}.${mspFile.extension}`;
		});
		this.ExcelService.incomingfile(E);
		this.ExcelService.importExcel().then((excelRes) => {
			const excelTabName = excelRes.sheetNameList[0];
			if (excelRes.sheets[excelTabName].data.length > 1000) {
				this.NotificationService.setNotificationMessage(this.labels['lbl_maximo_importacoes_ativos']);
				this.importFile.nativeElement.value = '';
				return;
			}

			const headerNameArray = [];
			const excelHeaderNameArray = [];
			for (const header of this.importHeaderFields) {
				const headerLabel = this.labels[header.label] ? normalizeString(this.labels[header.label]) : normalizeString(header.label);
				headerNameArray.push(headerLabel);
			}

			for (const header of excelRes.sheets[excelTabName].columns) {
				const headerLabel = this.labels[header] ? normalizeString(this.labels[header]) : normalizeString(header);
				excelHeaderNameArray.push(headerLabel);
			}
			if (
				this.CryptoService.hashCodeHex(headerNameArray.toString()) !=
				this.CryptoService.hashCodeHex(excelHeaderNameArray.toString())
			) {
				this.NotificationService.setNotificationMessage(this.labels.lbl_definicoes_coluna_errada_template);
				this.importFile.nativeElement.value = '';
				return;
			}

			const typeField = <genericFormI>this.importAllFields['cmdb']['type'];
			const typeFieldLabel = this.labels[typeField.label] ? this.labels[typeField.label] : typeField.label;
			const excelTypeIndex = excelRes.sheets[excelTabName].columns.findIndex((headerLabel) => {
				return normalizeString(headerLabel) == normalizeString(typeFieldLabel);
			});

			const excelIdIndex = excelRes.sheets[excelTabName].columns.findIndex((headerLabel) => {
				return normalizeString(headerLabel) == normalizeString('id');
			});

			const ignoreField = new Set(['id']);

			for (const excelLine of excelRes.sheets[excelTabName].data) {
				const newLine: tableLineI = {
					cells: [],
					loading: false,
					alert: { on: false, color: undefined, icon: undefined, tip: undefined },
				};

				const lineTypeLabel = excelLine[excelTypeIndex];
				const lineType = typeField.items.find((types) => {
					const typeLabel = this.labels[types.label] ? this.labels[types.label] : types.label;
					return normalizeString(typeLabel) == normalizeString(lineTypeLabel);
				});
				if (lineType == undefined) {
					this.NotificationService.setNotificationMessage(`${lineTypeLabel} ${this.labels.lbl_tipo_invalido}`);
					this.importFile.nativeElement.value = '';
					return;
				}

				if (excelLine[excelIdIndex] == '') this.importNewCiCount++;
				else this.importUpdateCiCount++;

				if (excelLine[excelIdIndex] == '' && !this.PermissionService.hasPermission('cmdb_inserir')) {
					//Sem permissão de criação
					newLine.alert = { on: true, color: 'danger', icon: 'faBan', tip: this.labels['lbl_sem_permissao_acao'] };
				} else if (this.checkPermissionByType(lineTypeLabel) == false) {
					//Sem permissão de edição
					newLine.alert = { on: true, color: 'danger', icon: 'faBan', tip: this.labels['lbl_sem_permissao_acao'] };
				}

				for (const [index, header] of this.importHeaderFields.entries()) {
					const fieldSource = normalizeString(header.tip);
					let formItem: genericFormI;
					if (!ignoreField.has(header.name)) {
						try {
							if (fieldSource == 'cmdb') formItem = this.importAllFields[fieldSource][header.name];
							else if ((fieldSource == 'ci' || fieldSource == 'extraction') && header.pseudoNames == undefined)
								formItem = this.importAllFields[lineType.name]['ci'][header.name];
							else if ((fieldSource == 'ci' || fieldSource == 'extraction') && header.pseudoNames != undefined)
								formItem = this.importAllFields[lineType.name]['ci'][header.pseudoNames[lineType.name]];
							else if (fieldSource == 'cf') formItem = this.importAllFields[lineType.name]['cf'][header.name];
						} catch {}
					}

					const newCell: tableCellI = {
						value: '',
						label: '',
						inputType: header.inputType,
						alert: false,
						alert_tip: '',
					};

					//Checking if it's a select
					if (
						(fieldSource == 'cmdb' && formItem != undefined && formItem['items']?.length > 0) ||
						(fieldSource != 'cmdb' && formItem != undefined && formItem['items']?.length > 0)
					) {
						if (
							formItem.required == false &&
							(excelLine[index] == undefined || excelLine[index] == '' || excelLine[index] == '0')
						)
							newCell.value = '0';
						else {
							const findItem = formItem.items.find((item) => {
								const itemLabel = this.labels[item.label] ? this.labels[item.label] : item.label;
								return normalizeString(excelLine[index]) == normalizeString(itemLabel);
							});
							newCell.label = excelLine[index];

							if (findItem == undefined) {
								newCell.alert = true;
								newCell.alert_tip = this.buildImportCellErrorMessage(header, excelLine[index], 'valor invalido');
								newLine.alert = {
									on: true,
									color: 'warning',
									icon: 'faTriangleExclamation',
									tip: newCell.alert_tip,
								};
							} else {
								newCell.value = findItem.values[0];
							}
						}

						//Checking if it's a text input
					} else {
						newCell.label = excelLine[index];
						newCell.value = excelLine[index];

						if (this.debugImport && formItem == undefined) {
							newCell.alert = true;
							newCell.alert_color = 'warning';
						}

						if (
							formItem?.required == true &&
							formItem?.hidden == false &&
							(newCell.value == undefined || newCell.value == '')
						) {
							newCell.alert = true;
							newCell.alert_tip = this.buildImportCellErrorMessage(header, newCell.value, 'campo obrigatorio nao preenchido');
							newLine.alert = {
								on: true,
								color: 'warning',
								icon: 'faTriangleExclamation',
								tip: newCell.alert_tip,
							};
						}
					}

					if (newCell.inputType == 'date' && newCell.value != undefined && newCell.value !== '') {
						let dateValue = newCell.value;

						if (typeof dateValue === 'string') {
							const dateValueTrimmed = dateValue.trim();
							const dateRegexYMD = /^(\d{4})\/(\d{2})\/(\d{2})$/;
							const matchYMD = dateValueTrimmed.match(dateRegexYMD);

							if (matchYMD) {
								const year = matchYMD[1];
								const month = matchYMD[2];
								const day = matchYMD[3];
								dateValue = `${day}/${month}/${year}`;
								newCell.value = dateValue;
								newCell.label = dateValue;
							}
						}

						// Validar se é string no formato DD/MM/YYYY
						if (typeof dateValue === 'string') {
							const dateRegex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
							const match = dateValue.trim().match(dateRegex);

							if (match) {
								// Validar se é uma data real válida
								const day = Number.parseInt(match[1], 10);
								const month = Number.parseInt(match[2], 10);
								const year = Number.parseInt(match[3], 10);

								const testDate = new Date(year, month - 1, day);
								if (testDate.getFullYear() !== year || testDate.getMonth() !== month - 1 || testDate.getDate() !== day) {
									// Data inválida (ex: 32/13/2025)
									newCell.alert = true;
									newCell.alert_tip = this.buildImportCellErrorMessage(header, dateValue, 'data invalida');
									newLine.alert = {
										on: true,
										color: 'warning',
										icon: 'faTriangleExclamation',
										tip: newCell.alert_tip,
									};
								}
							} else {
								// Formato inválido
								newCell.alert = true;
								newCell.alert_tip = this.buildImportCellErrorMessage(
									header,
									dateValue,
									'formato de data invalido. Use DD/MM/YYYY'
								);
								newLine.alert = {
									on: true,
									color: 'warning',
									icon: 'faTriangleExclamation',
									tip: newCell.alert_tip,
								};
							}
						} else {
							// Não é string (ex: número)
							newCell.alert = true;
							newCell.alert_tip = this.buildImportCellErrorMessage(
								header,
								dateValue,
								'formato de data invalido. Use DD/MM/YYYY'
							);
							newLine.alert = {
								on: true,
								color: 'warning',
								icon: 'faTriangleExclamation',
								tip: newCell.alert_tip,
							};
						}
					}

					newLine.cells.push(newCell);
				}

				if (newLine.alert.on == true) {
					this.importErrorCiCount++;
					if (excelLine[excelIdIndex] == '') this.importNewCiCount--;
					else this.importUpdateCiCount--;
				}
				this.importBodyFields.push(newLine);
			}

			this.importFile.nativeElement.value = '';
		});
	}

	handleImportAttachmentFile(event: Event): void {
		const target = event.target as HTMLInputElement;
		const file = target.files?.[0];

		if (!file) return;
		if (!this.finishedImport || this.importedCmdbIds.length === 0) {
			target.value = '';
			return;
		}

		this.isLoadingImportAttachment = true;
		this.FilesService.MSPFileFromFile(file)
			.then((mspFile) => {
				this.importAttachment = mspFile;
				this.importAttachmentName = `${mspFile.name}.${mspFile.extension}`;
				return this.attachImportAttachmentToImportedCis();
			})
			.catch(() => {
				this.clearImportAttachment();
				this.NotificationService.setNotificationMessage('Arquivo invalido para anexo em lote');
			})
			.finally(() => {
				this.isLoadingImportAttachment = false;
				target.value = '';
			});
	}

	clearImportAttachment(): void {
		this.importAttachment = null;
		this.importAttachmentName = '';
		if (this.importAttachmentFile?.nativeElement) {
			this.importAttachmentFile.nativeElement.value = '';
		}
	}

	importCisFromExcel(): void {
		if (this.isImportingCis.length > 0) return;

		try {
			this.importHasError = false;
			this.finishedImport = false;

			const typeField = <genericFormI>this.importAllFields['cmdb']['type'];
			const typeFieldIndex = this.importHeaderFields.findIndex((header) => {
				return header.name == 'type';
			});

			this.importIdNotification = this.LoadingNotificationService.setNotificationMessage(
				`${this.labels['lbl_importacao_ativos']}`,
				'loading',
				'faFileArrowUp'
			);
			this.runnedImport = true;

			// Filtrar apenas as linhas válidas (sem alertas)
			const validLines = this.importBodyFields.filter((line) => line.alert?.on !== true);

			if (validLines.length === 0) {
				this.finishImport();
				return;
			}

			// Processar sequencialmente
			this.processNextLine(validLines, 0, typeField, typeFieldIndex);
		} catch {
			this.isImportingCis = [];
			this.LoadingNotificationService.updateNotificationStatus(this.importIdNotification, 'error');
		}
	}

	// Processa as linhas de importação sequencialmente
	private processNextLine(validLines: any[], currentIndex: number, typeField: genericFormI, typeFieldIndex: number): void {
		// Verificar se todas as linhas foram processadas
		if (currentIndex >= validLines.length) {
			this.finishImport();
			return;
		}

		const line = validLines[currentIndex];

		// Marcar linha como em processamento
		this.isImportingCis.push(true);
		line.loading = true;

		// Construir body da requisição
		const body = this.buildRequestBody(line, typeField, typeFieldIndex);

		// Determinar se é criação ou atualização
		if (body['cmdb']['id'] != undefined && body['cmdb']['id'] != '' && body['cmdb']['id'] != '0') {
			this.processUpdateLine(line, body, validLines, currentIndex, typeField, typeFieldIndex);
		} else {
			this.processCreateLine(line, body, validLines, currentIndex, typeField, typeFieldIndex);
		}
	}

	private formatDateToSpecificFormat(dateString: string, dataFormat: string, timeFormat: string): string {
		if (!dateString || dateString == '') return '';
		if (dateString.split(' ').length == 1) dateString += ` 00:00`;

		let newDate: ShkDate;

		try {
			newDate = new ShkDate(dateString, { dateFormat: 'DMY', timeFormat: 'HMS', dateSeparator: '/', timeSeparator: ':' });
		} catch {
			newDate = new ShkDate(new Date(dateString));
		}

		newDate.dateFormat = <any>dataFormat;
		newDate.timeFormat = <any>timeFormat;
		newDate.dateSeparator = '/';

		return `${newDate.hours}:${newDate.minutes}` == '00:00' ? `${newDate.date}` : `${newDate.date} ${newDate.hours}:${newDate.minutes}`;
	}

	// Formata o valor da célula de acordo com o tipo de input
	private formatCellValue(cellValue: any, inputType: string): any {
		if (inputType === 'date') {
			return this.formatDateToSpecificFormat(cellValue, 'YMD', 'HMS');
		}
		return cellValue;
	}

	// Constrói o body da requisição para uma linha
	private buildRequestBody(line: any, typeField: genericFormI, typeFieldIndex: number): any {
		const body = {
			cmdb: {
				customer: this.ProfileService.userData().idCustomer,
			},
			ci: {},
			customFields: {},
		};

		const lineType = typeField.items.find((types) => {
			return types.values[0] == line.cells[typeFieldIndex].value;
		});

		for (const [index, header] of this.importHeaderFields.entries()) {
			const cellValue = line.cells[index].value;
			const formattedValue = this.formatCellValue(cellValue, header.inputType);

			switch (header.tip) {
				case 'CMDB': {
					body['cmdb'][header.name] = formattedValue;

					break;
				}
				case 'CI':
				case 'EXTRACTION': {
					const fieldName = header.pseudoNames ? header.pseudoNames[lineType.name] : header.name;
					body['ci'][fieldName] = formattedValue;

					break;
				}
				case 'CF': {
					body['customFields'][header.alias] = formattedValue;

					break;
				}
				// No default
			}
		}

		return body;
	}

	// Processa uma linha de atualização
	private processUpdateLine(
		line: any,
		body: any,
		validLines: any[],
		currentIndex: number,
		typeField: genericFormI,
		typeFieldIndex: number
	): void {
		const customLog = `${this.labels['lbl_ativo_atualizado_planilha_importacao']} - ${this.importFileName}`;

		this.CmdbRegisterPageService.updateCiWithBody(body, body['cmdb']['id'], customLog).subscribe({
			next: () => {
				this.handleLineSuccess(body['cmdb']['id'].toString(), line, 'atualizacao', () => {
					this.processNextLine(validLines, currentIndex + 1, typeField, typeFieldIndex);
				});
			},
			error: (error) => {
				this.handleLineError(
					line,
					'atualizacao',
					() => {
						this.processNextLine(validLines, currentIndex + 1, typeField, typeFieldIndex);
					},
					this.getImportLineErrorMessage(error, 'atualizacao')
				);
			},
		});
	}

	// Processa uma linha de criação
	private processCreateLine(
		line: any,
		body: any,
		validLines: any[],
		currentIndex: number,
		typeField: genericFormI,
		typeFieldIndex: number
	): void {
		const customLog = `${this.labels['lbl_ativo_criado_planilha_importacao']} - ${this.importFileName}`;

		this.CmdbRegisterPageService.createCiWithBody(body, customLog).subscribe({
			next: (response) => {
				const createdCiId = this.extractCiIdFromResponse(response, body);
				if (createdCiId) {
					this.handleLineSuccess(createdCiId, line, 'criacao', () => {
						this.processNextLine(validLines, currentIndex + 1, typeField, typeFieldIndex);
					});
				} else {
					this.handleLineError(
						line,
						'criacao',
						() => {
							this.processNextLine(validLines, currentIndex + 1, typeField, typeFieldIndex);
						},
						'CI criado, mas o ID nao foi retornado pela resposta'
					);
				}
			},
			error: (error) => {
				this.handleLineError(
					line,
					'criacao',
					() => {
						this.processNextLine(validLines, currentIndex + 1, typeField, typeFieldIndex);
					},
					this.getImportLineErrorMessage(error, 'criacao')
				);
			},
		});
	}

	private getImportLineErrorMessage(error: any, operationType: 'criacao' | 'atualizacao'): string {
		const fallback = `Falha ao ${operationType === 'criacao' ? 'criar' : 'atualizar'} CI`;

		if (error?.error?.ExtendedInfo) {
			try {
				const parsedError = JSON.parse(error.error.ExtendedInfo);
				const detailedMessage = this.buildImportDetailedErrorMessage(parsedError);
				if (detailedMessage) return detailedMessage;
				if (parsedError?.label) return parsedError.label;
				if (parsedError?.message) return parsedError.message;
			} catch {}
		}

		const candidates = [
			error?.error?.Message,
			error?.error?.message,
			typeof error?.error === 'string' ? error.error : '',
			error?.message,
			error?.statusText,
		];

		for (const candidate of candidates) {
			if (typeof candidate === 'string' && candidate.trim() !== '') return candidate.trim();
		}

		return fallback;
	}

	private buildImportDetailedErrorMessage(parsedError: any): string {
		if (!parsedError || typeof parsedError !== 'object') return '';

		const fieldLabel = parsedError.label || parsedError.field || '';
		const fieldValue = parsedError.value != undefined && parsedError.value !== '' ? `${parsedError.value}` : '';
		const fieldType = parsedError.type || '';

		if (fieldLabel && fieldValue && fieldType) {
			return `Campo ${fieldLabel} com valor \"${fieldValue}\" invalido para o tipo ${fieldType}`;
		}

		if (fieldLabel && fieldValue) {
			return `Campo ${fieldLabel} com valor \"${fieldValue}\" invalido`;
		}

		if (fieldLabel && parsedError.message) {
			return `${fieldLabel}: ${parsedError.message}`;
		}

		return '';
	}

	// Manipula o sucesso de uma linha - marca diretamente como sucesso
	private handleLineSuccess(ciId: string, line: tableLineI, operationType: 'criacao' | 'atualizacao', onComplete: () => void): void {
		line.alert.icon = 'faCircleCheck';
		line.alert.color = 'success';
		line.alert.tip = `CI ${operationType === 'criacao' ? 'criado' : 'atualizado'} com sucesso`;
		line.alert.on = false;
		if (/^\d+$/.test((ciId || '').toString().trim())) this.importedCmdbIds.push(ciId.toString().trim());
		this.finishLineProcessing(line, onComplete);
	}

	private attachImportAttachmentToImportedCis(): Promise<void> {
		const batchIds = [...new Set(this.importedCmdbIds.map((id) => (id || '').toString().trim()).filter((id) => /^\d+$/.test(id)))];

		if (!this.importAttachment || batchIds.length === 0) {
			return Promise.resolve();
		}

		const idNotif = this.LoadingNotificationService.setNotificationMessage(
			'Anexando arquivo aos CIs importados...',
			'loading',
			'faFileArrowUp'
		);

		return new Promise((resolve, reject) => {
			forkJoin(
				batchIds.map((id) =>
					this.CmdbRegisterPageAttachmentService.uploadFiles(id, this.importAttachment).pipe(
						catchError((error) => of({ error, id }))
					)
				)
			).subscribe({
				next: (results) => {
					const hasError = results.some((result: any) => !!result?.error);

					if (hasError) {
						this.LoadingNotificationService.updateNotificationStatus(idNotif, 'attention');
						this.NotificationService.setNotificationMessage(
							'Importacao concluida, mas houve falha ao vincular o anexo em parte dos CIs'
						);
						reject(new Error('Falha parcial ao anexar arquivo em lote'));
						return;
					}

					this.LoadingNotificationService.updateNotificationStatus(idNotif, 'success');
					this.NotificationService.setNotificationMessage('Anexo vinculado com sucesso aos CIs importados');
					resolve();
				},
				error: () => {
					this.LoadingNotificationService.updateNotificationStatus(idNotif, 'error');
					this.NotificationService.setNotificationMessage('Falha ao vincular o anexo aos CIs importados');
					reject(new Error('Falha ao anexar arquivo em lote'));
				},
			});
		});
	}

	// Manipula o erro de uma linha
	private handleLineError(
		line: tableLineI,
		operationType: 'criacao' | 'atualizacao',
		onComplete: () => void,
		tip = `Falha ao ${operationType === 'criacao' ? 'criar' : 'atualizar'} CI`
	): void {
		this.importHasError = true;

		if (line.alert?.on !== true) {
			this.importErrorCiCount++;
			if (operationType === 'criacao' && this.importNewCiCount > 0) this.importNewCiCount--;
			if (operationType === 'atualizacao' && this.importUpdateCiCount > 0) this.importUpdateCiCount--;
		}

		line.alert.icon = 'faTriangleExclamation';
		line.alert.color = 'danger';
		line.alert.on = true;
		line.alert.tip = tip;
		this.finishLineProcessing(line, onComplete);
	}

	// Finaliza o processamento de uma linha
	private finishLineProcessing(line: any, onComplete: () => void): void {
		line.loading = false;
		this.isImportingCis.pop();
		onComplete();
	}

	// Extrai o ID do CI da resposta do backend após criação
	private extractCiIdFromResponse(response: any, body: any): string | null {
		if (typeof response === 'string') {
			try {
				const parsed = JSON.parse(response);
				return this.extractCiIdFromResponse(parsed, body);
			} catch {}
		}

		const candidates: any[] = [
			response?.ID,
			response?.id,
			response?.cmdb_id,
			response?.data?.ID,
			response?.data?.id,
			response?.data?.cmdb_id,
			response?.cmdb?.id,
			response?.cmdb?.cmdb_id,
			response?.ci?.id,
			response?.ci?.cmdb_id,
			response?.ciArray?.[0]?.id,
			response?.ciArray?.[0]?.cmdb_id,
		];

		for (const value of candidates) {
			const asText = (value || '').toString().trim();
			if (/^\d+$/.test(asText)) return asText;
		}

		return null;
	}

	async finishImport() {
		await this.until(() => this.isImportingCis.length === 0);
		if (this.importHasError) {
			this.LoadingNotificationService.updateNotificationStatus(this.importIdNotification, 'attention');
		} else {
			this.LoadingNotificationService.updateNotificationStatus(this.importIdNotification, 'success');
		}
		this.finishedImport = true;
	}

	onCloseImportModal() {
		if (!this.runnedImport) {
			this.importBodyFields = [];
			this.importNewCiCount = 0;
			this.importUpdateCiCount = 0;
			this.importErrorCiCount = 0;
			this.clearImportAttachment();
		}
		this.importedCmdbIds = [];
	}

	searchCITable(page: number): void {
		const cisTableContainerElement = document.querySelector('#cisTableContainer');
		if (cisTableContainerElement != undefined) {
			cisTableContainerElement.scrollTop = 0;
			cisTableContainerElement.scrollLeft = 0;
		}

		this.isLoadingCiTable = true;

		if (this.searchCiTableReq) this.searchCiTableReq.unsubscribe();

		this.searchCiTableReq = this.CmdbHomeScreenService.searchCITable({
			page: page,
			searchParameters: this.tableSearch,
			sortBy: this.tableSort.sortBy,
			sortDown: this.tableSort.sortDown,
			recount: this.recount,
			showInactiveCis: this.showInactiveCis,
			noItemsSearch: false,
		}).subscribe({
			next: (ciTableArrRes) => {
				this.ciTableArr = ciTableArrRes.ciArr;
				this.ciTableArrCount = ciTableArrRes.ciArr.length;
				const shouldRecount = this.recount; // Salva o valor antes de resetar
				if (this.recount) this.ciTableCount = ciTableArrRes.count;
				this.ciTablePage = page;
				this.recount = false;

				// Buscar headers filtrados do backend quando houver uma nova busca (recount = true)
				if (shouldRecount) {
					this.CmdbHomeScreenService.getFilteredCITableHeaders(this.tableSearch, this.showInactiveCis)
						.subscribe({
							next: (filteredHeaders) => {
								const queryStringParameters = this.getQueryStringParams();
								this.ciTableHeader = filteredHeaders.map((header) => {
									const newHeader: mspTableHeaderI = {
										name: header.name,
										value: this.labels[header.label] ? this.labels[header.label] : header.label,
										colType: this.mapGenericInputTypeToTableColType(header.inputType),
										nowrap: true,
										items: header.items,
									};
									if (queryStringParameters[header.name] != undefined) {
										if (newHeader.colType === 'text') {
											newHeader.startSearch = queryStringParameters[header.name];
										} else {
											if (newHeader.items)
												for (const item of newHeader.items) {
													if (queryStringParameters[header.name].includes(item.values[0]?.toString()))
														item.selected = true;
												}
										}
									}
									return newHeader;
								});
								this.ciTableHeader.push({
									name: 'actionsTemplate',
									value: this.labels['lbl_bulletin_actions'],
									colType: 'none',
									template: this.actionsTemplate,
								});
							},
							error: (error) => {
								console.error('Erro ao buscar headers filtrados:', error);
							},
						})
						.add(() => {
							// Desligar loading da tabela após carregar os headers
							this.isLoadingCiTable = false;
							if (this.isFirstLoad) {
								this.isFirstLoad = false;
							}
							this.dropdown.name = '';
						});
				} else {
					// Se não precisa recarregar headers, desligar loading imediatamente
					this.isLoadingCiTable = false;
					if (this.isFirstLoad) {
						this.isFirstLoad = false;
					}
					this.dropdown.name = '';
				}
			},
		});
		this.finishLoading();
		// Atualizar URL com os parâmetros de busca
		this.updateUrlParams(page);
	}

	getSelectedCisIds(): string[] {
		return this.selectedCiTableArr.map((ci) => ci.id);
	}

	getSelectedCisUrl(type: 'read' | 'edit'): string {
		const idCiArray = this.getSelectedCisIds();
		idCiArray.sort();
		return `/cmdb/${idCiArray.join(',')}/${type}`;
	}

	deleteCi(ciId: string): void {
		this.CmdbHomeScreenService.deleteCis([ciId]).subscribe({
			next: () => {
				this.NotificationService.setNotificationMessage(this.labels.lbl_geral_desativado_com_sucesso);
				this.selectedCiTableArr = [];
				this.searchCITable(1);
			},
			error: () => {
				this.isLoadingCiTable = false;
			},
		});
	}

	deleteSelectedCis(e: Event): void {
		if (e) e.stopPropagation();
		const idCiArray = this.getSelectedCisIds();
		this.isLoadingCiTable = true;
		this.CmdbHomeScreenService.deleteCis(idCiArray).subscribe({
			next: () => {
				this.NotificationService.setNotificationMessage(this.labels.lbl_geral_desativado_com_sucesso);
				this.selectedCiTableArr = [];
				this.searchCITable(1);
			},
			error: () => {
				this.isLoadingCiTable = false;
			},
		});
	}

	updateSelectedCis(e: Event): void {
		e.stopPropagation();
		if (this.isUpdatingCiField) return;

		const idCiArray = this.getSelectedCisIds();

		const field = this.editField.name;
		const newValue = this.editField.values[0];
		const fieldItem = this.editField.items.find((item) => {
			return item.values[0] == newValue;
		});
		let newValueText = '';
		if (fieldItem == undefined) {
			newValueText = newValue;
		} else {
			newValueText = this.labels[fieldItem.label] ? this.labels[fieldItem.label] : fieldItem.label;
		}

		this.isUpdatingCiField = true;
		this.CmdbHomeScreenService.updateCis(idCiArray, field, newValue, newValueText)
			.subscribe({
				next: () => {
					this.NotificationService.setNotificationMessage(this.labels.lbl_successful_updated);
					this.selectedCiTableArr = [];
					this.selectedModal = '';
					this.searchCITable(1);
				},
				error: () => {
					this.NotificationService.setNotificationMessage('An error has occour, please try again');
				},
			})
			.add(() => {
				this.isUpdatingCiField = true;
			});
	}

	openCMDBTableContextMenu(): void {
		this.refreshCmdbContextMenu();
	}

	onSelectedRowsChange(selectedRows: ciInterface2[]): void {
		this.selectedCiTableArr = selectedRows;
		this.refreshCmdbContextMenu();
	}

	private refreshCmdbContextMenu(): void {
		this.cmdbContextMenu = [
			{
				name: this.labels.lbl_visualizar_selecionados,
				type: 'link',
				url: this.getSelectedCisUrl('read'),
				disabled: !this.hasPermissionForSelected(),
			},
			{
				name: this.labels.lbl_editar_selecionados,
				type: 'link',
				url: this.getSelectedCisUrl('edit'),
				disabled: !this.hasPermissionForSelected(),
			},
			{
				name: this.labels.lbl_desativar_selecionados,
				event: () => {
					this.deleteSelectedCis(null);
				},
				disabled: !this.hasPermissionForSelected(),
			},
			{
				name: this.labels.lbl_atualizacao_rapida,
				event: () => {
					this.openModal('editCI');
				},
				disabled: !this.hasPermissionForSelected(),
			},
		];
	}

	confirmButton(elementReference: HTMLElement, e: Event): void {
		e.stopPropagation();
		this.NotificationService.setNotificationMessage(this.labels.lbl_clique_confirmar_acao);
		elementReference.classList.add('confirmClick');
		setTimeout(() => {
			elementReference.classList.remove('confirmClick');
		}, 5000);
	}

	submitUpdate() {
		if (this.isUpdatingDigitalTerm) return;

		const selectedItem = this.ciTableArr[this.selectedIndex];
		let selectedUser: enduserInterface = { id: '', fullName: '' };
		let selectedLocation: locationInterface;

		if (this.cmdbDigitalTermPayload.user && this.cmdbDigitalTermPayload.user.trim() !== '') {
			selectedUser = this.availableEnduser.find((user) => user.fullName === this.cmdbDigitalTermPayload.user);
		}
		if (this.cmdbDigitalTermPayload.location && this.cmdbDigitalTermPayload.location.trim() !== '') {
			selectedLocation = this.availableLocation.find((location) => location.name === this.cmdbDigitalTermPayload.location);
		}
		this.cmdbDigitalTermPayload.oldUser = selectedItem.enduser;
		this.cmdbDigitalTermPayload.idOldUser = selectedItem.id;
		this.cmdbDigitalTermPayload.oldStatus = selectedItem.status;

		this.cmdbDigitalTermPayloadCopy = JSON.parse(JSON.stringify(this.cmdbDigitalTermPayload));
		this.cmdbDigitalTermPayload.user = selectedUser.fullName;
		this.cmdbDigitalTermPayload.idUser = selectedUser.id;
		this.cmdbDigitalTermPayload.idLocation = selectedLocation.id;

		if (
			this.cmdbDigitalTermPayload.checklist === -1 ||
			// this.cmdbDigitalTermPayload.generate_send === -1 ||
			this.cmdbDigitalTermPayload.return_or_exchange_equipment === -1 ||
			this.cmdbDigitalTermPayload.serial_number === '' ||
			this.cmdbDigitalTermPayload.third_party_user === -1 ||
			// this.cmdbDigitalTermPayload.user === '' ||
			this.cmdbDigitalTermPayload.user_disconnected === -1
		) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_preencha_todos_asteriscos);
			return;
		}

		this.saveCmdbDigitalTerm();
	}

	loadCmdbDigitalTerm(index: number): void {
		this.isLoadingDigitalTerm = true;
		if (this.digitalTermReq) this.digitalTermReq.unsubscribe();

		this.digitalTermReq = this.CmdbHomeScreenService.getCmdbDigitalTerm(this.ciTableArr[index].id).subscribe({
			next: (payload: CmdbDigitalTerm) => {
				if (payload.status === 204) {
					this.cmdbDigitalTermPayload = {
						id: '',
						cmdb_id: this.ciTableArr[index].id,
						attachment: '',
						checklist: -1,
						customer: null,
						generate_send: 0,
						generation_date: '',
						return_or_exchange_equipment: -1,
						serial_number: this.ciTableArr[index]?.identification || '',
						signature: '',
						term_type: '',
						third_party_user: -1,

						user: this.ciTableArr[index]?.enduser || '',
						location: this.ciTableArr[index]?.location || '',
						statusCmdb: this.ciTableArr[index]?.status || '',

						user_disconnected: -1,
						uuid: '',
					};
					this.selectedIndex = index;
					this.selectedModal = 'digitalTerm';
				} else {
					payload.statusCmdb = this.ciTableArr[index]?.status || '';
					payload.location = this.ciTableArr[index]?.location || '';

					this.cmdbDigitalTermPayload = payload;
					this.selectedIndex = index;
					this.selectedModal = 'digitalTerm';
				}
			},
		});

		this.digitalTermReq.add(() => {
			this.isLoadingDigitalTerm = false;
		});
	}

	saveCmdbDigitalTerm(): void {
		if (this.isUpdatingDigitalTerm) return;

		this.isUpdatingDigitalTerm = true;

		this.cmdbDigitalTermPayload.customerUrl = new URL(window.location.href).origin;

		if (this.cmdbDigitalTermPayload?.id) {
			const termId = this.cmdbDigitalTermPayload.id.toString();

			this.CmdbHomeScreenService.updateCmdbDigitalTerm(termId, this.cmdbDigitalTermPayload)
				.subscribe({
					next: () => {
						this.selectedModal = '';
						this.selectedIndex = null;
						this.isEditingTerm = false;
						this.NotificationService.setNotificationMessage(this.labels.lbl_termo_digital_enviado_sucesso);
						this.searchCITable(this.ciTablePage);
					},
					error: (errorRes) => {
						if (errorRes.error.ExtendedInfo && errorRes.error.ExtendedInfo != '') {
							const extendedInfo = this.labels[errorRes.error.ExtendedInfo]
								? this.labels[errorRes.error.ExtendedInfo]
								: errorRes.error.ExtendedInfo;
							this.NotificationService.setNotificationMessage(extendedInfo);
						}
					},
				})
				.add(() => {
					this.isUpdatingDigitalTerm = false;
				});
		} else {
			this.CmdbHomeScreenService.createCmdbDigitalTerm(this.cmdbDigitalTermPayload)
				.subscribe({
					next: (response) => {
						if (response.status === 201) {
							this.selectedModal = '';
							this.selectedIndex = null;
							this.isEditingTerm = false;
							this.cmdbDigitalTermPayload.id = response.data.ID;
							this.NotificationService.setNotificationMessage(this.labels.lbl_termo_digital_enviado_sucesso);
						} else if (response.status === 206) {
							this.isEditingTerm = true;
							this.NotificationService.setNotificationMessage(this.labels.lbl_termo_usuario_nao_associado);
							return;
						}

						this.searchCITable(this.ciTablePage);
					},
					error: (errorRes) => {
						if (errorRes.error.ExtendedInfo && errorRes.error.ExtendedInfo != '') {
							const extendedInfo = this.labels[errorRes.error.ExtendedInfo]
								? this.labels[errorRes.error.ExtendedInfo]
								: errorRes.error.ExtendedInfo;
							this.NotificationService.setNotificationMessage(extendedInfo);
						}
					},
				})
				.add(() => {
					this.isUpdatingDigitalTerm = false;
				});
		}
	}

	downloadDigitalTerm(file: any): void {
		// Decodificar o conteúdo de Base64
		const byteCharacters = atob(file.content);
		const byteNumbers: number[] = Array.from({ length: byteCharacters.length });
		for (let index = 0; index < byteCharacters.length; index++) {
			byteNumbers[index] = byteCharacters.charCodeAt(index);
		}
		const byteArray = new Uint8Array(byteNumbers);

		// Criar um Blob a partir do array de bytes
		const blob = new Blob([byteArray], { type: file.mimeType });

		// Criar um link temporário para o Blob
		const link = document.createElement('a');
		link.href = window.URL.createObjectURL(blob);
		link.download = file.name;

		// Adicionar o link ao DOM
		document.body.append(link);

		// Simular o clique no link para iniciar o download
		link.click();

		// Remover o link do DOM
		link.remove();

		// Liberar o objeto de URL
		window.URL.revokeObjectURL(link.href);
	}

	openModal(modalTab: string): void {
		this.selectedModal = modalTab;
	}

	closeModal(e?: Event): void {
		if (e && !(<HTMLElement>e.target).classList.contains('modal-background')) return;

		if ((this.selectedModal = 'digitalTerm')) {
			this.selectedIndex = null;
			this.isEditingTerm = false;
			if (this.digitalTermReq) this.digitalTermReq.unsubscribe();
		}

		this.selectedModal = '';
	}

	getCmdbTableColumns(): void {
		this.isLoadingCiTableHeader = true;
		this.CmdbHomeScreenService.getCITableHeaders().subscribe({
			next: (ciTableHeader) => {
				this.ciTableHeader = ciTableHeader.map((header) => {
					const newHeader: mspTableHeaderI = {
						name: header.name,
						value: this.labels[header.label] ? this.labels[header.label] : header.label,
						colType: this.mapGenericInputTypeToTableColType(header.inputType),
						nowrap: true,
						items: header.items,
					};
					return newHeader;
				});
				this.ciTableHeader.push({
					name: 'actionsTemplate',
					value: this.labels['lbl_bulletin_actions'],
					colType: 'none',
					template: this.actionsTemplate,
				});
				this.tableSort.sortBy = ciTableHeader[0].name;
				this.applyPendingUrlFilters();

				this.isLoadingCiTableHeader = false;
				this.recount = true;
				this.searchCITable(1);
			},
			error: (error) => {
				console.error('Erro ao buscar headers da tabela:', error);
				this.isLoadingCiTableHeader = false;
				this.NotificationService.setNotificationMessage('Erro ao carregar colunas da tabela de ativos.');
			},
		});
	}

	saveCmdbViewColumns(columnsToSave: genericFormI['rawValues']): void {
		if (this.isLoadingViewColumns == true) return;

		if (columnsToSave.length === 0) {
			this.NotificationService.setNotificationMessage(this.labels['lbl_geral_selecione_coluna']);
			return;
		}

		this.isLoadingViewColumns = true;
		this.CmdbHomeScreenService.saveCmdbViewColumns(columnsToSave)
			.subscribe({
				next: () => {
					this.NotificationService.setNotificationMessage(this.labels.lbl_successful_updated);
					this.getCmdbTableColumns();
				},
			})
			.add(() => {
				this.isLoadingViewColumns = false;
			});
	}

	checkPermissionByTypeOnTable(index?: number): boolean {
		if (index === undefined || !this.ciTableArr[index]) {
			return false;
		}

		const currentType = this.ciTableArr[index].type;

		this.CmdbPermissionsService.getCmdbPermissions().subscribe({
			next: (data) => {
				this.requiredPermissions = data;
			},
		});

		return this.requiredPermissions.some(
			(data) => this.labels[data.label] === currentType && this.PermissionService.hasPermission(data.permission)
		);
	}

	checkPermissionByType(type: string): boolean {
		console.log(this.requiredPermissions);
		const typeLabel = this.labels[type] ? this.labels[type] : type;
		for (let index = 0; index < this.requiredPermissions.length; index++) {
			if (this.labels[this.requiredPermissions[index].label] === typeLabel) {
				console.log(
					`Permission for type ${typeLabel} found: ${this.requiredPermissions[index].permission}. You got it ${this.PermissionService.hasPermission(this.requiredPermissions[index].permission)}`
				);
			}
		}
		return this.requiredPermissions.some(
			(data) => this.labels[data.label] === typeLabel && this.PermissionService.hasPermission(data.permission)
		);
	}

	hasPermissionForSelected(): boolean {
		if (this.selectedCiTableArr.length === 0) {
			return false;
		}

		return this.selectedCiTableArr.every((ci) => this.checkPermissionByType(ci.type));
	}

	setLocalstorage(key: string, value: any) {
		localStorage.setItem(key, value);
	}

	getQueryStringParams(): { [key: string]: string[] } {
		const queryString = window.location.search.slice(1);
		const parameters: { [key: string]: string[] } = {};
		const pairs = queryString.split('&');
		for (const pair of pairs) {
			const [key, value] = pair.split('=');
			if (key && value) {
				parameters[decodeURIComponent(key)] = decodeURIComponent(value).split(',');
			}
		}
		return parameters;
	}

	//Atualiza a URL com os parâmetros de busca atuais
	updateUrlParams(page: number): void {
		const queryParameters: any = {};

		if (page > 1) queryParameters.page = page;

		if (this.tableSearch.general && this.tableSearch.general.trim() !== '') {
			queryParameters.general = this.tableSearch.general;
		}

		if (this.tableSort.sortBy !== 'id') queryParameters.sortBy = this.tableSort.sortBy;
		if (this.tableSort.sortDown === true) queryParameters.sortDown = 'true';

		if (this.showInactiveCis === true) queryParameters.showInactive = 'true';

		// Adicionar filtros de campos
		for (const key of Object.keys(this.tableSearch)) {
			const values = this.tableSearch[key];
			if (Array.isArray(values) && values.length > 0) {
				const hasNonEmptyValue = values.some((v) => v !== null && v !== undefined && v !== '');
				if (hasNonEmptyValue) {
					// Filtrar valores vazios antes de adicionar
					const cleanValues = values.filter((v) => v !== null && v !== undefined && v !== '');
					queryParameters[key] = cleanValues.join(',');
				}
			}
		}

		// Atualizar URL sem recarregar a página
		this.cmdbListQueryParams = queryParameters;
		this.Router.navigate([], {
			relativeTo: this.ActivatedRoute,
			queryParams: queryParameters,
			replaceUrl: true, // Substituir a URL atual sem adicionar ao histórico
			skipLocationChange: false, // Permitir mudança na URL mas sem navegação
		});

		if (Object.keys(queryParameters).length > 0) {
			localStorage.setItem(this.cmdbListFiltersStorageKey, JSON.stringify(queryParameters));
		} else {
			localStorage.removeItem(this.cmdbListFiltersStorageKey);
		}

		this.finishLoading();
	}

	//Carrega filtros a partir dos parâmetros da URL (apenas uma vez na inicialização)
	loadFiltersFromUrl(): void {
		// Usar snapshot ao invés de subscribe para evitar navegação
		const parameters = this.ActivatedRoute.snapshot.queryParams;

		// Se não há parâmetros, não fazer nada
		if (Object.keys(parameters).length === 0) return;

		// Carregar página
		if (parameters['page']) {
			const page = Number.parseInt(parameters['page'], 10);
			if (!isNaN(page) && page > 0) {
				this.ciTablePage = page;
			}
		}

		// Carregar busca geral
		if (parameters['general']) {
			this.tableSearch.general = parameters['general'];
		}

		// Carregar sortBy
		if (parameters['sortBy']) {
			this.tableSort.sortBy = parameters['sortBy'];
		}

		// Carregar sortDown
		if (parameters['sortDown'] === 'true') {
			this.tableSort.sortDown = true;
		}

		// Carregar showInactive
		if (parameters['showInactive'] === 'true') {
			this.showInactiveCis = true;
			this.setLocalstorage('cmdbhpShowInactiveCis', true);
		}

		this.pendingUrlParams = parameters;
	}

	//Aplica os filtros pendentes da URL após os headers estarem carregados
	applyPendingUrlFilters(): void {
		if (!this.pendingUrlParams || this.ciTableHeader.length === 0) return;

		const parameters = this.pendingUrlParams;

		// Aplicar filtros de campos
		for (const header of this.availableCiTableColumns) {
			if (parameters[header.name]) {
				const parameterValue = parameters[header.name];

				const values = parameterValue.split(',').map((v) => {
					const number_ = Number(v);
					return isNaN(number_) ? v.trim() : number_;
				});
				this.tableSearch[header.name] = values;
			}
		}

		this.pendingUrlParams = null;
		// Fazer a busca com os filtros carregados
		this.recount = true;
		this.searchCITable(this.ciTablePage);
	}

	sendBatchTermAfterImport(): void {
		const batchIds = [...new Set(this.importedCmdbIds.map((id) => (id || '').toString().trim()).filter((id) => /^\d+$/.test(id)))];

		if (batchIds.length === 0) {
			this.NotificationService.setNotificationMessage('Nenhum CI valido encontrado para envio em lote dos termos digitais');
			return;
		}

		const idNotif = this.LoadingNotificationService.setNotificationMessage(
			'Enviando termos digitais em lote...',
			'loading',
			'faFileArrowUp'
		);

		this.CmdbHomeScreenService.sendBatchTermByImport(batchIds).subscribe({
			next: () => {
				this.LoadingNotificationService.updateNotificationStatus(idNotif, 'success');
				this.NotificationService.setNotificationMessage(this.labels.lbl_termo_digital_enviado_sucesso);
			},
			error: () => {
				this.LoadingNotificationService.updateNotificationStatus(idNotif, 'error');
			},
		});
	}
}
